import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { ProfileService } from '../profile.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  isFlyout = false;

  constructor(
    public profileService: ProfileService,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document) {
      this.route.queryParams.subscribe(async params => {
        const flyout = params['fly'];
        if (flyout === '1') {
          this.isFlyout = true;
        }
      });
    }

    ngOnInit(): void {
    }

    get curStep() {
      return this.profileService.curStep;
    }

    get curStep1() {
      return this.curStep === 1;
    }

    onStepChange(event) {
      this.profileService.curStep = 1;
    }

    onStepChange2(event) {
      this.profileService.curStep = 2;
    }
}
